import React from "react";
import { connect } from "react-redux";
import Component from "./component";
import { setFormData, nextStep, previousStep } from "../pickup-form.actions";
import { getPhoneAvailable } from "api/users";
import Tracking from "utils/tracking";
import { showToastError } from "../../../helpers";

const mapStateToProps = (state, ownProps) => ({});

const mapDispatchToProps = (dispatch) => {
  return {
    onSubmit: (form) =>
      new Promise((resolve, reject) => {
        let query = {
          phoneNumber: form.phoneNumber,
        };

        return getPhoneAvailable(query)
          .then((response) => {
            Tracking.track("Step 4: Entered Phone Number");
            const isNewDonor = response.data.data[0].isAvailable;

            if (isNewDonor) {
              Tracking.track("Step 4: New Phone Number (New Donor)");
            } else {
              Tracking.track("Step 4: Existing Phone Number (Donor Exists)");
            }

            dispatch(
              setFormData({
                isNewDonor: isNewDonor,
                phoneNumber: form.phoneNumber,
              })
            );
            resolve();
          })
          .catch((err) => {
            Tracking.track("Step 4: Phone Number Failed");
            showToastError();
            reject(err);
          });
      }),

    onSubmitSuccess: () => {
      dispatch(nextStep());
    },
    previousStep: () => dispatch(previousStep()),
  };
};

// Connect to the store using a container component
const withConnect = connect(mapStateToProps, mapDispatchToProps)(Component);

export default withConnect;
